module.exports = __webpack_public_path__ + "img/undraw_source_code_re_wd9m.c4f23ffa.svg";